import * as PIXI from 'pixi.js';
import Config from './Config';

export default class Foreground extends PIXI.Container {
  constructor() {
    super();

    this.sprites = [];
  }

  onResourcesLoaded() {
    this.sprites = [
      new PIXI.TilingSprite(PIXI.Loader.shared.resources['fg1'].texture, Config.GAME_WIDTH, Config.GAME_HEIGHT),
    ];

    this.addChild(...this.sprites);
  }

  update(dt, [
    background,
    foreground,
    player,
    ground,
    ...treasures
  ], viewport) {
    this.sprites.forEach((sprite, spriteIndex) => {
      sprite.tilePosition.x = Math.min(1, -player.positionX * ( 1 + (spriteIndex + 1) * 0.1)) % sprite.texture.width;
    });
  }
}
